'use client';

import { Container, useModal, TypeformSnippet } from '..';
import { CaptionWithMB, H2 } from './styleConstants';
import React from 'react';
import styles from './UltrasignalSection.module.css';

const UltraSignalTFModal = () => {
  return (
    <div className={styles.tfModal}>
      <TypeformSnippet
        typeformId="WwKw67nO"
        frameTitle="Apply for Ultrasignal"
        className="typeform-container"
      />
    </div>
  );
};

export const UltrasignalSection = ({ className }: { className?: string }) => {
  const ModalClient = useModal();

  const showApplyModal = () => {
    ModalClient.set(<UltraSignalTFModal />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <section className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <Container className={styles.container}>
        <div className={styles.textContent}>
          <CaptionWithMB>Solution</CaptionWithMB>
          <H2
            className={styles.heading}
            style={{ margin: '0 auto 12px', color: '#000000' }}
          >
            World&apos;s first wearable-based developer platform
          </H2>
          {/* <Subtitle style={{ margin: '0 auto' }}>
            A unified enterprise-grade dashboard for teams and clinicians to
            track sleep, recovery, movement, cycles, and long-term health using
            continuous biomarkers.
          </Subtitle> */}
        </div>
        <div className={styles.mediaContainer}>
          <div className={styles.iframeContainer}>
            <iframe
              title="Unicorn Studio"
              src={'https://unicorn.studio/embed/C0XlH8smsOLQgZ0RTY3U'}
              loading="lazy"
            ></iframe>
          </div>
          <div className={styles.contentContainer}>
            {/* <p className="tag">ULTRASIGNAL</p> */}
            <H2 className={styles.heading}>UltraSignal</H2>
            <p className={styles.subtitle}>
              Using the Ring AIR&apos;s Photoplethysmography (PPG), temperature
              and accelerometer data stream, developers can now build bespoke
              algorithms on top of their data.
            </p>
            <div className={styles.ctaContainer}>
              <button className={styles.primaryButton} onClick={showApplyModal}>
                Request access
              </button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
